import { Model } from 'core/model/Model';
import { Collection } from 'core/model/Collection';

export const modelFinder = <
  TYPE extends { id: string | number },
  MOD extends Model<TYPE>,
  COL extends Collection<MOD> = Collection<MOD>,
  KEY extends keyof TYPE & string = keyof TYPE & string
>(
  collection: COL,
  param: KEY
) => {
  const map = collection.reduce((acc, curr) => {
    if (curr.get(param)) {
      acc.set(curr.get(param), curr);
    }
    return acc;
  }, new Map<TYPE[KEY], MOD>());
  return (name: TYPE[KEY]) => map.get(name);
};
